import { getRemoteAppConfig } from '../utils'
import { getLocaleLanguage, LanguageType } from '../utils/language'

const config = {}

const setConfig = (remoteConfig) => {
  Object.assign(config, remoteConfig)
  return config
}

export const getConfig = () => config
Object.assign(window, { getConfig })

export const COOKIE_KEYS = {
  BASE_LOGIN_KEY: 'INTL_GCLOUD_TICKET',
  LOGIN_KEY: getConfig().cookieName// 登录cookie key名
}

/**
 * @description merge 流程，优先级最高 remote config
 * 1. remote config
 * 2. rum time config <env.xxx.ts>
 * 3. local default config.default.ts
 */
export const initAppConfig = async () => {
  const config = await getRemoteAppConfig(
    process.env.NODE_ENV
  )
  if (config) {
    setConfig(config)
    console.log('App start config', getConfig())
    return getConfig()
  }
  return null
}

// 官网产品介绍页
export const getInGameURL = () => {
  const currentStoreLanguage = getLocaleLanguage() || LanguageType.en_US
  // 正式未上线
  return `${getConfig().websiteURL}?ingame_language=${currentStoreLanguage}`
}



// WEBPACK FOOTER //
// ./src/config/index.js